<template>
    <div>
        <div class="row">
            <div class='col'>
                <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#openAgenda" data-whatever="@fat">Nova agenda</button>
            </div>

        </div>
        <div class="row">
                <div class="col">
                    <div class="table">
                        <table class="table-hover table-borderless">
                            <thead>
                                <tr>
                                    <th>Data / Hora</th>
                                    <th>Distribuidor</th>
                                    <th>Lote</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for='(lista,l) in listaAgenda' :key="l">
                                    <td>{{ lista.data_evento }}</td>
                                    <td>{{lista.distribuidor_id}}</td>
                                    <td>{{lista.lote_id}}</td>
                                </tr>
                                
                            </tbody>
                        </table>
                    </div>
                </div>
        </div>

<div class="modal fade" id="openAgenda" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">New message</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="form-group">
            <label for="recipient-name" class="col-form-label">Data Evento:</label>
            <input type="date" v-model="agenda.data_evento" class="form-control" >
          </div>
          <div class="form-group">
            <label for="recipient-name" class="col-form-label">Hora Evento:</label>
            <input type="date" v-model="agenda.hora_evento" class="form-control" >
          </div>
          <div class="form-group">
            <label for="recipient-name" class="col-form-label">E-mail:</label>
            <input type="date" v-model="agenda.email" class="form-control" >
          </div>
         
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
        <button type="button" class="btn btn-primary" @click='saveAgenda'>Salvar</button>
      </div>
    </div>
  </div>
</div>
    </div>
</template>
<script>
export default {
    name:'agenda-distribuidor',
    data(){
        return {
            listaAgenda: [],
            agenda: {
                id: null,
                data_evento: '',
                hora_evento: '',
                distribuidor_id: 0,
                lote_id: null,
                email: '',
                user_id: 0

            }
        }
    },
    methods: {
        getListAgenda(){
            const vm = this;
            axios.get('/adm/agenda-distribuidor/lista').then((response)=>{
                console.log(response.data);
                vm.listaAgenda = response.data;
            }).catch(error =>{
                console.log(error);
            })
        },
        saveAgenda(){
            const vm = this;
            if(this.agenda.data_evento === ''){
                alert('Favor informar a data do evento');
                return;
            }
            axios.post('/adm/agenda-distribuidor', this.agenda).then((response)=>{
                console.log(response.data);
                vm.getListAgenda();
                $('openAgenda').modal('hide');
            }).catch(error =>{
                console.log(error);
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_agenda/index.vue